import { ReactNode } from 'react'

import '@hotmart/cosmos/dist/form/input-validate.css'

interface Props {
  hasError?: boolean,
  errorMessage?: ReactNode,
  hint?: ReactNode
}

const InputFeedback = ({ hasError = false, errorMessage = '', hint = '' }: Props) => {
  if (hasError) {
    return (
      <div className="invalid-feedback _d-block">
        {errorMessage}
      </div>
    )
  }

  return hint ? <div className="_text-1 _text-500 _mt-1">{hint}</div> : null
}

export default InputFeedback
